import { SidebarMenu } from "../../core/models/sidebar-menu.model";
import { UserRole } from "../enums/userRoles.enum";

export const SidebarMenuData: SidebarMenu[] = [
  {
    title: "Dashboard",

    iconCollapsed: "/assets/images/sidebar-icons/dashboard-icon.svg",
    iconExpanded: "/assets/images/sidebar-icons/dashboard-icon-active.svg",
    isCollapsed: true,
    isActive: true,
    url: "dashboard",
    isVisible: true,
    roles: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.PowerUse,
      UserRole.Sales,
      UserRole.VR,
    ],
    emails: [],
  },
  {
    title: "BC Ledger",
    iconCollapsed: "/assets/images/sidebar-icons/ledger-icon.svg",
    iconExpanded: "/assets/images/sidebar-icons/ledger-icon-active.svg",
    isCollapsed: true,
    isActive: false,
    url: "bcledger",
    isVisible: true,
    roles: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.PowerUse,
      UserRole.Sales,
      UserRole.VR,
    ],
    emails: [],
  },
  {
    title: "Tasks",
    iconCollapsed: "/assets/images/sidebar-icons/task-icon.svg",
    iconExpanded: "/assets/images/sidebar-icons/task-icon-active.svg",
    isCollapsed: true,
    isActive: false,
    divider: true,
    url: "task-management",
    isVisible: true,
    child: [
      {
        id: 1,
        title: "Quick Task",
        url: "task-management?quicktask=true",
        isActive: false,
        emails: [],
      },
    ],
    roles: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.PowerUse,
      UserRole.Sales,
      UserRole.VR,
    ],
    emails: [],
  },
  {
    title: "Orders",
    iconCollapsed: "/assets/images/sidebar-icons/order-icon.svg",
    iconExpanded: "/assets/images/sidebar-icons/order-icon-active.svg",
    isCollapsed: true,
    child: [
      {
        id: 1,
        title: "New",
        url: "orders/order-header",
        isActive: false,
        isActivated: false,
        emails: [],
      },
    ],
    isActive: false,
    url: "orders/all-sales-listing",
    isVisible: true,
    roles: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.PowerUse,
      UserRole.Sales,
      UserRole.VR,
    ],
    emails: [],
  },
  {
    title: "Proposal",
    iconCollapsed: "/assets/images/sidebar-icons/proposal-icon.svg",
    iconExpanded: "/assets/images/sidebar-icons/proposal-icon-active.svg",
    isCollapsed: true,
    child: [
      {
        id: 1,
        title: "New",
        url: "proposal/add-header",
        isActive: false,
        isActivated: false,
        emails: [],
      },
    ],
    isActive: false,
    url: "proposal",
    isVisible: true,
    roles: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.PowerUse,
      UserRole.Sales,
      UserRole.VR,
    ],
    emails: [],
  },
  {
    title: "Projects",
    iconCollapsed: "/assets/images/sidebar-icons/project-icon.svg",
    iconExpanded: "/assets/images/sidebar-icons/project-icon-active.svg",
    isCollapsed: true,
    child: [
      {
        id: 1,
        title: "Archived Projects",
        url: "project-workflow/archive",
        isActive: false,
        emails: [],
      },
      {
        id: 2,
        title: "Approval",
        url: "project-workflow/approval",
        isActive: false,
        emails: [],
      },
    ],
    isActive: false,
    url: "project-workflow",
    isVisible: false,
    roles: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.PowerUse,
      UserRole.Sales,
      UserRole.VR,
    ],
    emails: [],
  },
  {
    title: "Sample PO",
    iconCollapsed: "/assets/images/sidebar-icons/sample-icon.svg",
    iconExpanded: "/assets/images/sidebar-icons/sample-icon-active.svg",
    isCollapsed: true,
    child: [
      {
        id: 1,
        title: "New",
        url: "samplepo/add-samplepo",
        isActive: false,
        emails: [],
      },
    ],
    isActive: false,
    url: "samplepo",
    isVisible: true,
    roles: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.PowerUse,
      UserRole.Sales,
      UserRole.VR,
    ],
    emails: [],
  },

  {
    title: "Inventory",
    divider: true,
    iconCollapsed: "/assets/images/sidebar-icons/inventory-icon.svg",
    iconExpanded: "/assets/images/sidebar-icons/inventory-icon-active.svg",
    isCollapsed: true,
    child: [
      {
        id: 1,
        title: "Inventory Sales",
        url: "orders/inventory-sales-listing?module=inventory-sales",
        isActive: false,
        emails: [],
      },
      {
        id: 2,
        title: "Inventory Purchases",
        url: "inventory-purchase/inventory-purchase-listing",
        isActive: false,
        emails: [],
      },
      {
        id: 3,
        title: "Products",
        url: "products",
        isActive: false,
        emails: [],
      },
    ],
    isActive: false,
    url: "orders/inventory-sales-listing?module=inventory-sales",
    isVisible: true,
    inventoryAccess: true,
    roles: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.PowerUse,
      UserRole.Sales,
      UserRole.VR,
    ],
    emails: [],
  },

  // {
  //   title: "Contacts",
  //   iconCollapsed: "/assets/images/sidebar-icons/contact-icon.svg",
  //   iconExpanded: "/assets/images/sidebar-icons/contact-icon-active.svg",
  //   isCollapsed: true,
  //   child: [
  //     {
  //       id: 1,
  //       title: "New",
  //       url: "prospects/All/add-new-prospect",
  //       isActive: false,
  //       emails: [],
  //     },
  //     {
  //       id: 2,
  //       title: "Hot",
  //       url: "prospects/Hot",
  //       isActive: false,
  //       emails: [],
  //     },
  //     {
  //       id: 3,
  //       title: "Warm",
  //       url: "prospects/Not",
  //       isActive: false,
  //       emails: [],
  //     },
  //     {
  //       id: 3,
  //       title: "Cold",
  //       url: "prospects/Forgot",
  //       isActive: false,
  //       emails: [],
  //     },
  //   ],
  //   isActive: false,
  //   url: "prospects/All",
  //   isVisible: true,
  //   roles: [
  //     UserRole.Admin,
  //     UserRole.Manager,
  //     UserRole.PowerUse,
  //     UserRole.Sales,
  //     UserRole.VR,
  //   ],
  //   emails: [],
  // },

  {
    title: "Admin",

    iconCollapsed: "/assets/images/sidebar-icons/admin-icon.svg",
    iconExpanded: "/assets/images/sidebar-icons/admin-icon-active.svg",
    isCollapsed: true,
    child: [
      {
        id: 9,
        title: "Users",
        isActive: false,
        url: "users",
        isCollapsed: true,
        isActivated: false,
        subChild: [
          {
            id: 92,
            title: "Biller/Collector",
            url: "users/add-biller-collector",
            isActive: false,
            emails: [],
          },
        ],
        roles: [UserRole.Admin],
        emails: [],
      },
      {
        id: 1,
        title: "Quick Verify",
        url: "clients/active/quick-verify",
        isActive: false,
        emails: [],
      },
      {
        id: 2,
        title: "Clients",
        isCollapsed: true,
        isActivated: false,
        subChild: [
          {
            id: 21,
            title: "Project Access Group",
            url: "project-workflow/client-group",
            isActive: false,
            emails: [],
          },
          {
            id: 22,
            title: "Buyer",
            url: "project-workflow/buyer",
            isActive: false,
            emails: [],
          },
        ],
        url: "clients/active",
        isActive: false,
        emails: [],
      },
      {
        id: 3,
        title: "Vendors",
        url: "vendors",
        isActive: false,
        isCollapsed: true,
        isActivated: false,
        subChild: [
          {
            id: 31,
            title: "Specials",
            url: "specials",
            isActive: false,
            emails: [],
          },
        ],
        emails: [],
      },
      {
        id: 4,
        title: "Reports",
        url: "reports",
        isActive: false,
        emails: [],
      },
      {
        id: 5,
        title: "Invoice Preview",
        url: "invoice-preview",
        isActive: false,
        emails: [],
      },
      {
        id: 6,
        title: "CDI",
        url: "cdi",
        isActive: false,
        emails: [],
      },
      {
        id: 8,
        title: "Support Allocation",
        url: "support-allocation",
        isActive: false,
        emails: [],
      },
      {
        id: 10,
        title: "Management",
        isActive: false,
        url: "management/shipping-method-order",
        isCollapsed: true,
        isActivated: false,
        subChild: [
          {
            id: 101,
            title: "Shipping Method",
            url: "management/shipping-method-order",
            isActive: false,
            emails: [],
          },
          {
            id: 102,
            title: "Multi Ledger",
            url: "multi-ledger-association",
            isActive: false,
            emails: [],
          },
          {
            id: 103,
            title: "Program ",
            url: "programs",
            isActive: false,
            emails: [],
          },
          {
            id: 104,
            title: "Report Footer",
            url: "management/report-footer-templates",
            isActive: false,
            emails: [],
          },
          {
            id: 105,
            title: "W9/ACH Document",
            url: "management/w9-document",
            isActive: false,
            emails: [],
          },
        ],
        roles: [UserRole.Admin, UserRole.Manager],
        emails: [],
      },
    ],
    isActive: false,
    url: "#",
    isVisible: true,
    roles: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.PowerUse,
      UserRole.Sales,
      UserRole.VR,
    ],
    emails: [],
  },
  {
    title: "Freight Quote",
    iconCollapsed: "/assets/images/sidebar-icons/freight-icon.svg",
    iconExpanded: "/assets/images/sidebar-icons/freight-icon-active.svg",
    isCollapsed: true,
    isActive: false,
    url: "/freight-quote/listing",
    isVisible: true,
    roles: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.PowerUse,
      UserRole.Sales,
      UserRole.VR,
    ],
    emails: [],
  },
  {
    title: "Training Platform",
    iconCollapsed: "/assets/images/sidebar-icons/traning-icon.svg",
    iconExpanded: "/assets/images/sidebar-icons/traning-icon-active.svg",
    isCollapsed: true,
    isActive: false,
    url: "https://nadel.lessonly.com/content",
    isVisible: true,
    roles: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.PowerUse,
      UserRole.Sales,
      UserRole.VR,
    ],
    emails: [],
  },
];
